import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClienteUpdateComponent } from './cliente-update/cliente-update.component';
import { ClienteIndexComponent } from './cliente-index/cliente-index.component';
import { ClienteCreateComponent } from './cliente-create/cliente-create.component';
import { ClienteViewComponent } from './cliente-view/cliente-view.component';
import { RouterModule, Routes } from '@angular/router';
import { NgxKuvToolsModule } from 'ngx-kuv-tools';
import { NgxKuvUtilsModule } from 'ngx-kuv-utils';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

const routes: Routes = [
  { path: '', redirectTo: 'index', pathMatch: 'full' },
  { path: 'index', component: ClienteIndexComponent },
];

@NgModule({
  declarations: [
    ClienteUpdateComponent,
    ClienteIndexComponent,
    ClienteCreateComponent,
    ClienteViewComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
    NgxKuvUtilsModule,
    NgxKuvToolsModule

  ]
})
export class ClienteModule { }
